<template>
    <div class="detail page">
        <div v-if="object">
            <main>
                <div class="detail__header pt-24 pb-24">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="d-flex align-items-center"></div>
                            <div class="col-2 col-lg-1">
                                <button @click="$router.back()" class="btn-icon icon-caret-left"></button>
                            </div>
                            <div class="col-8 col-lg-5 text-center text-lg-left">
                                <h1 class="h1">{{ objectTitle }}</h1>
                                <h4 class="h5 d-none d-lg-block">Adres</h4>
                                <h5 class="h4 d-none d-lg-block">{{ object.address.street }} {{ object.address.number + object.address.number_suffix }}, {{ object.address.postalcode }} {{ object.address.city }}</h5>
                            </div>


                            <div class="col-12 d-block d-lg-none">
                                <h4 class="h5">Adres</h4>
                                <h5 class="h4">{{ object.address.street }} {{ object.address.number + object.address.number_suffix }}, {{ object.address.postalcode }} {{ object.address.city }}</h5>
                            </div>

                            <div class="col-12 col-lg-6">
                                <div class="row h-100 align-items-end">
                                    <div class="col-4 col-lg-3">
                                        <h4 class="h5">Huurprijs</h4>
                                        <h5 class="h4">€ {{ object.price_value }} /mnd</h5>
                                    </div>
                                    <div class="col-4 col-lg-3">
                                        <h4 class="h5">Slaapkamers</h4>
                                        <h5 class="h4">{{ object.characteristics.sleeping_rooms }} slaapkamer<span v-if="object.characteristics.sleeping_rooms !== 1">s</span></h5>
                                    </div>
                                    <div class="col-4 col-lg-3">
                                        <h4 class="h5">Oppervlakte</h4>
                                        <h5 class="h4">{{ object.characteristics.surface }} m²</h5>
                                    </div>
                                    <div class="col-12 col-lg-3"  v-if="object.status === 'Beschikbaar'">
                                        <div class="d-flex justify-content-lg-end">
                                            <button class="btn btn-like-large icon-heart" @click="like()" :class="{ liked: liked }">Voorkeur</button>

                                            <div class="house-tooltip">Woning toegevoegd aan je <a @click="toPreferences">favorieten</a></div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="detail__header--overlay">
                        <button @click="hideOverlay"  class="btn btn-primary btn-white-40">Behouden</button>
                        <button @click="dislike" class="btn btn-red">Verwijderen</button>
                    </div>

                </div>

                <detail-slider
                        :slide="object.images.extra"
                        :mainslide="object.images.main"
                ></detail-slider>

                <div class="detail__body pt-24 pb-24">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-12 offset-lg-1 col-lg-5">
                                <div class="detail-content">
                                    <h2 class="h2">Omschrijving</h2>
                                    <p>
                                        {{ object.description }}
                                    </p>
                                </div>
                            </div>
                            <div class="col-12 offset-lg-1 col-lg-4">
                                <div class="detail-details">
                                    <h2 class="h2">Details</h2>
                                    <div class="row detail-row align-items-end">
                                        <div class="col-7">
                                            <h3 class="h2 font-weight-light">Status</h3>
                                        </div>
                                        <div class="col-5">
                                            <h3 v-if="object.status === 'Onder optie'" class="h2 consultation">{{ object.status }}</h3>
                                            <h3 v-if="object.status === 'Beschikbaar'" class="h2 available">{{ object.status }}</h3>
                                            <h3 v-if="object.status === 'Verhuurd onder voorbehoud'" class="h2 rented">{{ object.status }}</h3>
                                            <h3 v-if="object.status === 'Verhuurd per maand'" class="h2 rented">{{ object.status }}</h3>

                                        </div>
                                    </div>
                                    <div class="row detail-row align-items-end">
                                        <div class="col-7">
                                            <h3 class="h2 font-weight-light">Woonoppervlakte</h3>
                                        </div>
                                        <div class="col-5">
                                            <h3 class="h2">{{ object.characteristics.surface }} m²</h3>
                                        </div>
                                    </div>
                                    <div class="row detail-row align-items-end">
                                        <div class="col-7">
                                            <h3 class="h2 font-weight-light">Huurprijs</h3>
                                        </div>
                                        <div class="col-5">
                                            <h3 class="h2">€ {{ object.price_value }},- p/m</h3>
                                        </div>
                                    </div>
                                    <div v-if="object.service_costs" class="row detail-row align-items-end">
                                        <div class="col-7">
                                            <h3 class="h2 font-weight-light">Servicekosten</h3>
                                        </div>
                                        <div class="col-5">
                                            <h3 class="h2">€ {{ object.service_costs }},-</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row align-items-end detail__body--bottom">
                            <div class="col-12 offset-lg-1 col-lg-5">
                                <detail-map-slider
                                        :download="true"
                                        :slide="object.images.maps"
                                ></detail-map-slider>
                            </div>

                            <div v-if="object.images.slider && object.images.slider.length" class="col-12 col-lg-6">
                                <detail-map-slider
                                    :download="false"
                                    :slide="object.images.slider"
                                ></detail-map-slider>
                            </div>
 
                            <div v-else class="col-12 col-lg-6">
                                <detail-card
                                    :houseid="object.id"
                                ></detail-card>
                            </div>
                        </div>

                    </div>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
    import DetailSlider from '../components/DetailSlider.vue'
    import DetailMapSlider from '../components/DetailMapSlider.vue'
    import DetailCard from '../components/DetailCard.vue'

    export default {
        name:'detail',
        components: {
            DetailSlider,
            DetailMapSlider,
            DetailCard
        },
        mounted() {
            this.object = this.$getObject(this.$route.params.object_id)
        },
        data() {
            return {
                title: "detail",
                object: null
            }
        },
        computed: {
            liked () {
                return this.$store.state.favorites.includes(this.object.id)
            },
            objectTitle () {
              if(this.$store.state.apiData.building_title){
                let type = this.$store.state.apiData.building_title
                if(type === 'address'){
                  return this.object.address.street + ' ' + this.object.address.number + this.object.address.number_suffix
                }
              }
              return 'Bouwnummer ' + this.object.build_number
            }
        },
        methods: {
            toPreferences() {
                this.showPopup = false
                document.body.classList.remove('drop-down-open-pref')
                this.$router.push({ name: 'preferences' })
            },
            like () {
                if(!this.liked){

                  let maxPreferences = this.$store.state.apiData.max_preferences
                  if(maxPreferences && this.$store.state.favorites.length >= maxPreferences){
                    this.$store.commit('favoriteLimitReached', true)
                    return
                  }

                    this.$store.commit('addFavorite', this.object.id)
                    const tooltip =  this.$el.querySelector('.house-tooltip')
                    tooltip.classList.add('active')

                    setTimeout(function(){
                        tooltip.classList.remove('active')
                    }, 2000);
                } else {
                    this.$el.querySelector('.detail__header--overlay').classList.add('active')
                }
            },
            dislike(){
                this.$store.commit('removeFavorite', this.object.id)
                this.$el.querySelector('.detail__header--overlay').classList.remove('active')
            },
            hideOverlay() {
                this.$el.querySelector('.detail__header--overlay').classList.remove('active')
            }
        },
    }
</script>
